import { ReactComponent as DeleteOutlineIcon } from 'assett/icons/circle_cancel_icon.svg';
import { Button, IconButton } from 'styles';
import { useTranslation } from 'utils/translations';

type Props = {
	iconButton?: boolean;
	onClickCallback: () => void;
};

const ButtonDeleteClaim = ({ iconButton, onClickCallback }: Props) => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});

	const handleClick = () => {
		onClickCallback();
	};

	return (
		<>
			{iconButton ? (
				<IconButton
					aria-label={`${tClientLabels('dashboard.buttons.deleteClaim')}`}
					onClick={handleClick}
				>
					<DeleteOutlineIcon />
				</IconButton>
			) : (
				<Button
					variant="outlined"
					aria-label={`${tClientLabels('dashboard.buttons.deleteClaim')}`}
					onClick={handleClick}
				>
					{tClientLabels('dashboard.buttons.deleteClaim')}
				</Button>
			)}
		</>
	);
};

export default ButtonDeleteClaim;
